/*
  hly-gallery-arrows: drives the prev/next buttons rendered by
  snippets/hly-gallery-arrows.liquid.

  Dawn's slider buttons scroll `.product__media-list`, which only works on mobile:
  at >=750px the thumbnail layouts display:none every item except `.is-active`.
  So instead of scrolling, we ask <media-gallery> to activate the neighbouring
  media, the same call its thumbnail buttons make. Wraps around at both ends.

  Delegated from `document` so it survives section re-renders (theme editor,
  variant changes) without rebinding.
*/
(function () {
  if (window.hlyGalleryArrows) return;
  window.hlyGalleryArrows = true;

  /*
    Must be scoped to the slides: each one also contains a modal-opener button
    carrying its own `data-media-id` (the bare media id, no section prefix), and a
    bare `[data-media-id]` query walks into those instead of the next photo.
    Variant media is hidden by CSS when `hide_variants` is on, except the first item.
  */
  function selectableItems(viewer) {
    var slides = viewer.querySelectorAll('.product__media-list > .product__media-item[data-media-id]');
    return Array.from(slides).filter(function (item, index) {
      return index === 0 || !item.classList.contains('product__media-item--variant');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hly-gallery-arrow]');
    if (!button) return;

    var gallery = button.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var items = selectableItems(viewer);
    if (items.length < 2) return;

    var current = items.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    var step = button.dataset.hlyGalleryArrow === 'next' ? 1 : -1;
    var target = items[(current + step + items.length) % items.length];

    gallery.setActiveMedia(target.dataset.mediaId, false);
  });
})();
